import { render } from "./TheTickerTitle.vue?vue&type=template&id=77d07548"
import script from "./TheTickerTitle.vue?vue&type=script&lang=js"
export * from "./TheTickerTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__